// extracted by mini-css-extract-plugin
module.exports =  {"horizontal":"Progress-horizontal-module__horizontal___kLQxl"};